import React from "react";
import classes from "./Column.module.scss";
import Card from "../Card/Card";
import { useDroppable } from "@dnd-kit/core";
import { useSortable, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const Column = ({ boardId, column }) => {
  const {
    attributes,
    listeners,
    setNodeRef: setSortableRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id, data: { type: "column" } });

  const { setNodeRef: setDroppableRef, isOver } = useDroppable({
    id: column.id,
    data: { type: "column", columnId: column.id },
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const taskIds = column.tasks.map((task) => task.id);

  return (
    <section
      ref={setSortableRef}
      style={style}
      className={`${classes.column} ${isDragging ? classes.isDragging : ""}`}
    >
      <h3 className={classes.columnName} {...attributes} {...listeners}>
        <span></span> {column.name}
      </h3>
      <SortableContext items={taskIds} strategy={verticalListSortingStrategy}>
        <section
          ref={setDroppableRef}
          className={`${classes.tasks} ${isOver ? classes.tasksDropTarget : ""}`}
        >
          {column.tasks.map((task) => (
            <Card key={task.id} boardId={boardId} columnId={column.id} task={task} />
          ))}
        </section>
      </SortableContext>
    </section>
  );
};

export default Column;
